import { Injectable } from '@angular/core';

declare global {
  interface Window {
    pendo?: {
      initialize: (config: PendoInitConfig) => void;
      identify: (config: PendoIdentifyConfig) => void;
      isReady: () => boolean;
    };
  }
}

interface PendoVisitor {
  id: string;
  email?: string;
  full_name?: string;
  role?: string;
  firm?: string;
}

interface PendoAccount {
  id: string;
}

interface PendoInitConfig {
  visitor: PendoVisitor;
  account?: PendoAccount;
}

interface PendoIdentifyConfig {
  visitor: PendoVisitor;
  account?: PendoAccount;
}

@Injectable({
  providedIn: 'root',
})
export class PendoService {
  private initialized = false;

  initialize(visitor: PendoVisitor, account?: PendoAccount): void {
    if (!window.pendo) {
      console.warn('Pendo not loaded');
      return;
    }

    if (this.initialized) {
      console.warn('Pendo already initialized');
      return;
    }

    const config: PendoInitConfig = {
      visitor,
      account,
    };

    window.pendo.initialize(config);
    this.initialized = true;
  }

  identify(visitor: PendoVisitor, account?: PendoAccount): void {
    if (!window.pendo) {
      console.warn('Pendo not loaded');
      return;
    }

    if (!this.initialized) {
      console.warn('Pendo not initialized');
      return;
    }

    const config: PendoIdentifyConfig = {
      visitor,
      account,
    };

    window.pendo.identify(config);
  }

  isReady(): boolean {
    return !!window.pendo?.isReady();
  }
}
